/* eslint-disable vue/no-mutating-props */
<template>
  <div class="single-line-field w-full">
    <p for="input" class="block text-sm mb-2 font-semibold text-argus-forest-800">
      {{ field.label }}
      <span v-if="field.required" class="text-argus-error text-sm">*</span>
    </p>
    <input
      type="text"
      ref="input"
      name="input"
      class="w-full px-3 py-2 text-sm text-argus-forest-600 border border-argus-border focus:border-argus-border rounded-lg placeholder-argus-forest-600 placeholder-opacity-50"
      :placeholder="field.placeholder"
      :value="value"
      autocomplete="off"
      data-private
      @input="updateValue"
      v-maska="mask ? maskMap[mask] || (mask.includes('#') ? mask : '') : ''"
    />
    <template v-if="field.error || !!errorMessage">
      <p class="text-argus-error text-sm py-[4px]">{{ errorMessage }}</p>
    </template>
    <template v-else-if="field.help_text">
      <p class="text-argus-forest-600 text-sm py-[4px]">{{ field.help_text }}</p>
    </template>
  </div>
</template>
<script>
// import validator from 'validator'
import { vMaska } from 'maska/vue'

export default {
  props: {
    field: Object,
    mask: {
      type: String,
    },
  },
  directives: { maska: vMaska },
  emits: ['update'],
  computed: {
    isValid() {
      if (!this.field.value && this.field.required) {
        return false
      }

      return true
    },
  },
  data() {
    return {
      touched: false,
      errorMessage: '',
      value: '',
      maskMap: {
        phone: '(###) ###-####',
        ssn: '###-##-####',
        zipcode: '#####',
        date: '##/##/####',
        email: '',
        number: '#*',
        currency: {
          mask: '$#####',
          tokens: {
            '#': { pattern: /[0-9]/ },
          },
        },
      },
    }
  },
  mounted() {
    this.value = this.field.value
  },
  methods: {
    updateValue(ev) {
      this.touched = true
      this.$emit('update', ev.target.value)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = 'This field is required.'
          return
        }
      } else {
        this.errorMessage = ''
      }
    },
  },
}
</script>
<style scoped>
input[type='text']:focus {
  outline: none;
  box-shadow: none;
}
</style>
